import { ECommissionType } from 'v2/components/Pages/Product/Edit/classes/Product';
import { EChargeType } from 'v2/interfaces/product';
import { ruleRunner } from 'validations/ruleRunner';
import { ruleIfEqualsAND, required, minimun, ruleIf, ruleIfValue, maximum } from 'validations/rules';

const MAX_COMMISSION = 99;

const Validations = [
  ruleRunner(
    'comission_value',
    'porcentagem',
    ruleIfValue('charge_type', EChargeType.SINGLE, minimun(0.01)),
    ruleIfEqualsAND(
      [
        { field: 'charge_type', value: EChargeType.SINGLE },
        { field: 'comission_type', value: ECommissionType.PERCENTAGE },
      ],
      maximum(MAX_COMMISSION)
    )
  ),
  ruleRunner('comission_type', ruleIfValue('charge_type', EChargeType.SINGLE, required)),
  ruleRunner(
    'membership_comission_value',
    'porcentagem',
    ruleIfEqualsAND(
      [
        {
          field: 'charge_type',
          value: EChargeType.SUBSCRIPTION,
        },
        {
          field: 'membership_fee',
          value: true,
        },
      ],
      minimun(1)
    ),
    ruleIfEqualsAND(
      [
        {
          field: 'charge_type',
          value: EChargeType.SUBSCRIPTION,
        },
        {
          field: 'membership_comission_type',
          value: ECommissionType.PERCENTAGE,
        },
        {
          field: 'membership_fee',
          value: true,
        },
      ],
      maximum(MAX_COMMISSION)
    )
  ),
  ruleRunner('membership_comission_type', ruleIfValue('charge_type', EChargeType.SUBSCRIPTION, required)),
  ruleRunner(
    'recurring_comission_value',
    'comissão',
    ruleIfEqualsAND(
      [
        { field: 'has_children', value: false },
        { field: 'charge_type', value: EChargeType.SUBSCRIPTION },
      ],
      minimun(5)
    ),
    ruleIfEqualsAND(
      [
        { field: 'has_children', value: false },
        { field: 'charge_type', value: EChargeType.SUBSCRIPTION },
        { field: 'recurring_comission_type', value: ECommissionType.PERCENTAGE },
      ],
      maximum(MAX_COMMISSION)
    )
  ),
  ruleRunner(
    'recruit_commission_value',
    'porcentagem',
    ruleIf('recruit', minimun(0.01)),
    ruleIfEqualsAND(
      [
        { field: 'recruit', value: true },
        { field: 'recruit_commission_type', value: ECommissionType.PERCENTAGE },
      ],
      maximum(MAX_COMMISSION)
    )
  ),
  ruleRunner('recruit_commission_type', ruleIf('recruit', required)),
];

export default Validations;
